import { Factory } from 'rosie';
import './lib/uuid';

Factory.define('IncomingConcurrentSessionNotification');

Factory.define('IncomingConcurrentSessionNotificationWithDefaults')
  .extend('IncomingConcurrentSessionNotification')
  .attr('id', 'incoming-session-id')
  .attr('profile', () => Factory.attributes('SessionCustomerWithDefaults'))
  .attr('sessionType', 'SMS');

Factory.define('IncomingConcurrentSessionNotificationWithAbandonedCall')
  .extend('IncomingConcurrentSessionNotificationWithDefaults')
  .attr('sessionType', 'ABANDONED_CALL');

Factory.define('IncomingConcurrentSessionNotificationWithChat')
  .extend('IncomingConcurrentSessionNotificationWithDefaults')
  .attr('sessionType', 'CHAT');

Factory.define('IncomingConcurrentSessionNotificationWithEmail')
  .extend('IncomingConcurrentSessionNotificationWithDefaults')
  .attr('sessionType', 'EMAIL');

Factory.define('IncomingConcurrentSessionNotificationWithFBMessage')
  .extend('IncomingConcurrentSessionNotificationWithDefaults')
  .attr('sessionType', 'FB_MESSENGER');

Factory.define('IncomingConcurrentSessionNotificationWithSMS')
  .extend('IncomingConcurrentSessionNotificationWithDefaults')
  .attr('sessionType', 'SMS');

Factory.define('IncomingConcurrentSessionNotificationWithVoicemail')
  .extend('IncomingConcurrentSessionNotificationWithDefaults')
  .attr('sessionType', 'VOICEMAIL');

Factory.define('IncomingConcurrentSessionNotificationWithWhatsApp')
  .extend('IncomingConcurrentSessionNotificationWithDefaults')
  .attr('sessionType', 'WHATSAPP');



// WEBPACK FOOTER //
// ./factories/incoming_concurrent_session_notification_factory.js